var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components custimer-service-btn"},[_c('img',{staticClass:"cs-img",attrs:{"src":require('@/assets/icons/icon-customer-service.png')},on:{"click":_vm.toCs}}),_c('div',{staticClass:"text"},[_vm._v("客服")])])}
var staticRenderFns = []

export { render, staticRenderFns }